<template>
    <div>
        <Card :padding="0">
            <!--标题-->
            <p slot="title" class="card-title">
                {{chartsTitle}}
            </p>
            <!--查看更多-->
            <a href="#" slot="extra" v-show="isShowMore" @click.prevent="changeLimit">
                查看更多
            </a>
            <!--图表-->
            <div :style="{height: height}">
                <div style="width:100%;height:100%;" :id="chartsId" v-show="!isShow"></div>
                <div class="chart-error" v-show="isShow">
                    <div class="detail">
                        <span class="detail">暂无数据</span>
                    </div>
                </div>
            </div>
        </Card>
    </div>
</template>

<script>
    export default {
        name: "histogram-charts",
        props: {
            chartsTitle: String,//图表标题
            chartsId: String,//图表id
            height: String,//图表id
            productKey: String,//产品id
            histogramTooltip: String,//柱状图提示语
            isSchool: Boolean,//展示的是否为学校
            isIntervalDisplay: Boolean,//是否间隔显示数据
            isShowMore: Boolean,//是否展示查看更多
            isShowMoreData: String,//是否展示查看更多
            isClickCharts: Boolean,//是否可以点击柱状图
            colorArr: {
                type: Array,
                default: () => [
                    {offset: 0, color: "#39C6E9"},
                    {offset: 0.5, color: "#A3E5F5"},
                    {offset: 1, color: "#A3E5F5"}
                ]
            },
            fontColor: {
                type: String,
                default: '#757C8C'
            },
            fontSize: {
                type: String,
                default: '12px'
            },
            //是否显示DataZoom
            isShowDataZoom: {
                type: Boolean,
                default: false
            },
            //是否停止DataZoom的功能
            isDisableDataZoom: {
                type: Boolean,
                default: true
            },
            bottomHeight: {
                type: String,
                default: '60px'
            },
        },
        data() {
            return {
                isShow: false,//默认不展示缺醒图
                bottomHeightLocal: ''
            }
        },
        methods: {
            /**
             * 查看更多数据
             */
            changeLimit() {
                this.$emit('look-more-data', this.chartsId, this.productKey);
            },
            /**
             *渲染图表
             */
            initDataSource(data, xDataArr, seriesDataArr) {
                let _this = this;
                //根据isSchool字段来初始化bottomHeight
                this.initBottomHeight();
                let dataSource = _this.$echarts.init(
                    document.getElementById(_this.chartsId)
                );
                //强制更新dom
                _this.$forceUpdate();
                // _this.isShow = data.length <= 0;
                let tooltipHead = "";//定义悬浮框的提示语前半部分
                let tooltipCompany = "";//定义悬浮框的提示语后半部分
                switch (_this.histogramTooltip) {
                    case 'useSecond':
                        tooltipHead = '使用' + '：';
                        tooltipCompany = '次';
                        break;
                    case "useDay":
                        tooltipHead = '使用' + '：';
                        tooltipCompany = '天';
                        break;
                    case "install":
                        tooltipHead = '安装' + '：';
                        tooltipCompany = '块';
                        break;
                    case "people":
                        tooltipHead = '使用：';
                        tooltipCompany = '人';
                        break;
                    case "addSchool":
                        tooltipHead = '新增：';
                        tooltipCompany = '个';
                        break;
                    case "addUser":
                        tooltipHead = '新增：';
                        tooltipCompany = '人';
                        break;
                    case "hwNumDay":
                        tooltipHead = '布置：';
                        tooltipCompany = '题';
                        break;
                    case "burnPoint":
                        tooltipHead = '埋点数：';
                        tooltipCompany = '条';
                        break;
                }
                const option = {
                        tooltip: {
                            trigger: "axis",
                            axisPointer: {
                                // 坐标轴指示器，坐标轴触发有效
                                type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
                            },
                            //自定义悬浮框内容
                            formatter: function (params) {
                                var color = _this.colorArr[0].color;//图例颜色
                                var htmlStr = '<div>';
                                htmlStr += params[0].name + '<br/>';//x轴的名称
                                //添加圆点
                                htmlStr += '<span style="margin-right:5px;display:inline-block;width:10px;height:10px;border-radius:5px;background-color:' + color + ';"></span>';
                                //添加一个汉字，动态的自定义文本内容
                                htmlStr += tooltipHead + params[0].value + tooltipCompany;
                                htmlStr += '</div>';
                                return htmlStr;
                            }
                        },
                        dataZoom: [
                            {
                                show: this.isShowDataZoom,
                                realtime: true,
                                start: this.isDisableDataZoom ? 0 : 60,
                                end: 100,
                            },
                            {
                                disabled: this.isDisableDataZoom,
                                type: 'inside',
                                realtime: true,
                                start: 60,
                                end: 100

                            }
                        ],
                        xAxis: {
                            type: "category",
                            data: xDataArr,
                            axisLabel: {
                                textStyle: {
                                    color: _this.fontColor, //颜色
                                    fontSize: _this.fontSize  //大小
                                },
                                interval: _this.isIntervalDisplay === true ? Math.round(xDataArr.length / 10) : 0,
                                rotate: _this.isSchool === true ? 20 : 40
                            }
                        },
                        yAxis: {
                            type: "value",
                            axisLabel: {
                                formatter: '{value}' + tooltipCompany
                            },
                            textStyle: {
                                color: _this.fontColor, //颜色
                                fontSize: _this.fontSize  //大小
                            }
                        },
                        grid: {
                            // left: 75,
                            bottom: _this.bottomHeightLocal
                        },
                        series: [
                            {
                                data: seriesDataArr,
                                type: 'bar',
                                itemStyle: {
                                    normal: {
                                        label: {
                                            show: _this.isIntervalDisplay !== true, //开启显示
                                            position:
                                                "top", //在上方显示
                                            textStyle:
                                                {
                                                    //数值样式
                                                    color: _this.fontColor,
                                                    fontSize: _this.fontSize
                                                }
                                            ,
                                            formatter: function (params) {
                                                if (params.value > 1000) {
                                                    let value = parseInt(params.value / 1000);
                                                    return value + '千+';
                                                } else if (params.value > 10000) {
                                                    let value = parseInt(params.value / 10000);
                                                    return value + '万+';
                                                } else {
                                                    return params.value + tooltipCompany;
                                                }
                                            }
                                        }
                                        ,
                                        color: new _this.$echarts.graphic.LinearGradient(0, 0, 0, 1, _this.colorArr)
                                    }
                                },
                                barGap: "-100%",
                                barCategoryGap: "40%"
                            }
                        ]
                    }
                ;
                dataSource.setOption(option);
                if (_this.isClickCharts) {
                    dataSource.on('click', function (params) {
                        _this.$emit('click-more-data', params, _this.chartsId, _this.productKey);
                    });
                }
                window.addEventListener("resize", function () {
                    dataSource.resize();
                });
            },
            /**
             * 根据isSchool字段来初始化bottomHeight 所有引用的地方兼容后删除
             */
            initBottomHeight() {
                this.bottomHeightLocal = this.bottomHeight;
                if (this.isSchool) {
                    this.bottomHeightLocal = '100px';
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../style/common";
</style>
